import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Global } from './global';
import { Observable } from "rxjs";
import { UsuarioService } from "./usuario.service";
import { ConfiguracionesService } from "./configuraciones.service";

@Injectable()

export class TecnicosService{

  public url: string;
  public token = null;
  public config = null;

  constructor(
    public _http: HttpClient,
    private _usuarioService: UsuarioService,
    private _configuracionesService: ConfiguracionesService,
  ){
    this.url = Global.url;
    this.token = this._usuarioService.getToken();
    this.config = this._configuracionesService.getConfig( );
  }

  obtenerTecnicos(  ):Observable<any>{

    let headers = new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization',  this.token);

    var respuesta: any = this._http.get(this.url + "tecnicos/listado", {headers: headers});

    return respuesta;

  }

  async obtenerTecnico( id_tecnico ){

    let headers = new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization',  this.token);

    var respuesta: any = await this._http.get(this.url + "tecnicos/obtenertecnico/"+id_tecnico, {headers: headers}).toPromise();

    return respuesta;

  }

  async registrarTecnico( datos ){

    let data = JSON.stringify( {
      "datos": datos
    } );

    let params = 'data='+data;

    let headers = new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization',  this.token);

    var respuesta: any = await this._http.post(this.url + "tecnicos/registrar", params, {headers: headers}).toPromise();

    return respuesta;

  }

  async actualizarTecnico( datos ){

    let data = JSON.stringify( {
      "datos": datos
    } );

    let params = 'data='+data;

    let headers = new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization',  this.token);

    var respuesta: any = await this._http.post(this.url + "tecnicos/actualizar", params, {headers: headers}).toPromise();

    return respuesta;

  }

  eliminarTecnico( id ):Observable<any>{

    let headers = new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Authorization',  this.token);

    var respuesta: any = this._http.delete(this.url + "tecnicos/eliminar/" + id, {headers: headers});

    return respuesta;

  }

}
